import React from 'react';
import { ReactComponent as CrossIconFill } from 'images/icon-cross-small.svg';
import styles from './ContactCloseButton.module.scss';

interface Props {
    onKeyPress: (evt: React.KeyboardEvent) => void;
    onClick?: () => void;
}

const ContactCloseButton = ({ onKeyPress, onClick }: Props) => {
    return (
        <div
            tabIndex={0}
            role="button"
            onKeyPress={onKeyPress}
            className={styles.closeButton}
            onClick={onClick}
            data-test-id="contactCloseButton"
        >
            <CrossIconFill />
        </div>
    );
};

export default ContactCloseButton;
